<template>
  <div class="addStudent">
    <Form
      class="form com-margin-top"
      ref="couponForm"
      :model="couponForm"
      :rules="ruleValidate"
      label-position="right"
      :label-width="120"
    >
      <FormItem label="选择优惠券" prop="coupon">
        <Tag
          type="border"
          closable
          v-if="couponForm.coupon.id"
          @on-close="couponForm.coupon = {}"
        >{{couponForm.coupon.name}}</Tag>
        <Button type="default" @click="showSelectCoupon=true">
          <i class="ivu-icon ivu-icon-ios-add"></i>
          选择优惠券
        </Button>
      </FormItem>
      <FormItem label="选择赠送对象" prop="students">
        <Tag
          type="border"
          closable
          v-for="student in couponForm.students"
          :key="student.uid"
          @on-close="studentDelete(student.uid)"
        >{{student.nickname}}</Tag>
        <Button type="default" @click="showSelectStudent=true">
          <i class="ivu-icon ivu-icon-ios-add"></i>
          添加对象
        </Button>
      </FormItem>
    </Form>
    <div class="submit">
      <Button size="large" type="primary" @click="presentCoupon">保存并返回</Button>
    </div>
    <Modal
      class="grid-select"
      v-model="showSelectCoupon"
      title="选择优惠券"
      @on-ok="confirmSelectCoupons"
      width="800"
      scrollable
    >
      <CouponSelect
        ref="coupon"
        selectType="single"
        :selectedItems="[couponForm.coupon]"
        keepSelected
      ></CouponSelect>
    </Modal>
    <Modal
      class="grid-select"
      v-model="showSelectStudent"
      title="选择学员"
      @on-ok="confirmSelectStudents"
      width="800"
      scrollable
    >
      <StudentSelect ref="student" :selectedItems="couponForm.students" keepSelected></StudentSelect>
    </Modal>
  </div>
</template>

<script>
import StudentSelect from "@/components/GridSelect/StudentSelect.vue";
import CouponSelect from "@/components/GridSelect/CouponSelect.vue";
export default {
  components: {
    StudentSelect,
    CouponSelect
  },
  data() {
    return {
      couponForm: {
        students: [],
        coupon: ""
      },
      ruleValidate: {
        coupon: [
          {
            required: true,
            type: "object",
            message: "请选择优惠券",
            trigger: "change"
          }
        ],
        students: [
          {
            required: true,
            type: "array",
            min: 1,
            message: "赠送对象必须选择",
            trigger: "change"
          }
        ]
      },
      showSelectStudent: false,
      showSelectCoupon: false
    };
  },
  created() {},
  methods: {
    studentDelete(id) {
      let students = this.couponForm.students;
      for (let i = 0; i < students.length; i++) {
        if (students[i].uid == id) {
          students.splice(i, 1);
          break;
        }
      }
    },
    confirmSelectStudents() {
      let list = this.$refs.student.getSelectList();
      this.couponForm.students = list;
      this.showSelectStudent = false;
    },
    confirmSelectCoupons() {
      let list = this.$refs.coupon.getSelectList();
      this.couponForm.coupon = list[0]; //？？？？？？？？？？？？？？？？？
      this.showSelectCoupon = false;
    },
    presentCoupon() {
      this.$refs["couponForm"].validate(valid => {
        if (valid) {
          this.$http
            .post("/api/handSel/coupon", {
              coupon_id: this.couponForm.coupon.id,
              user_ids: this.userId(this.couponForm.students)
            })
            .then(res => {
              if (res.err) {
                this.$Message.error(res.err[0]);
              } else {
                this.$router.go(-1);
              }
            });
        } else {
          this.$message.error("您有未填项！");
        }
      });
    },
    userId(students) {
      let arry = [];
      for (let i = 0; i < students.length; i++) {
        arry.push(students[i].uid);
      }
      return arry.join(",");
    }
  }
};
</script>

<style lang="scss" scoped>
.addStudent {
  .form {
    width: 800px;
  }
  .submit {
    button:first-child {
      margin-left: 120px;
      margin-top: 80px;
    }
  }
  button {
    width: 115px;
    text-align: center;
  }
}
</style>
